<template>
  <div>
    <v-card v-if="pgUrl === null" class="mt-12 mx-auto" max-width="80%">
      <v-row class="text-left">
        <v-col>
          <v-card-text style="margin-left: 6%; font-size: 20px">
            <v-icon class="mr-1" style="color: #59065d; font-size: 30px"
              >mdi-account</v-icon
            >Customer Id :
            <b>{{ $store.state["auth"].storePaymentData.customerId }}</b>
          </v-card-text>
          <!-- <h6>
           
          </h6> -->
        </v-col>

        <v-col>
          <v-card-text style="font-size: 20px; margin-left: -16px">
            <v-icon class="mr-1" style="color: #59065d; font-size: 30px"
              >mdi-cash-usd</v-icon
            >Recharge Amount: <strong>{{ $toFixed(monthlyCost) }}</strong>
          </v-card-text>
          <!-- <h6>
           
          </h6> -->
        </v-col>
      </v-row>
      <v-row class="text-center">
        <!-- <v-col>
          <v-card-text>
            <v-icon class="mr-1" style="color: #59065d"> mdi-email</v-icon>Email
            Id
          </v-card-text>
          <h6 class="ml-3">
            <v-text-field
              type="number"
              required
              label="Enter Email Id"
              v-model="emailId"
              placeholder="Enter Email Id"
            />
          </h6>
        </v-col> -->

        <!-- <v-col>
          <v-card-text>
            <v-icon class="mr-1" style="color: #59065d">mdi-phone</v-icon>Mobile
            Number
          </v-card-text>
          <h6>
            <b>1234567890</b>
          </h6>
        </v-col> -->
        <v-col>
          <v-text-field
            style="margin-left: 10%; margin-right: 30%"
            type="email"
            required
            v-model="emailId"
            prepend-icon="mdi-email"
            label="Enter Email Id"
            placeholder="Enter Email Id"
          />
        </v-col>
        <v-col>
          <v-text-field
            style="margin-right: 30%"
            required
            v-model="phoneNumber"
            prepend-icon="mdi-phone"
            label="Enter Mobile Number"
            placeholder="Enter Mobile Number"
          />
        </v-col>
      </v-row>

      <v-form>
        <v-card-actions v-if="getCount == 0">
          <div class="mx-auto mt-5">
            <v-btn @click="proceedToPay" color="primary" class="mb-8 topup">
              Proceed To Pay
            </v-btn>
          </div>
        </v-card-actions>
        <v-card-actions v-if="getCount == 1">
          <div class="mx-auto mt-2">
            <v-btn
              @click="proceedToEassyPay"
              color="primary"
              class="mb-8 topup"
            >
              Proceed To Pay
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
    <payment-start
      v-else
      :action="pgUrl"
      :params="pgParams"
      :checksum="checkSum"
    />
    <!-- <payment-start-eassy-buzz
      v-if="easyUrl != null"
      :params="eassyParams"
      :action="easyUrl"
    /> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PaymentStart from "../TopUps/PaymentStart.vue";

import {
  createRequestQuickPay as createRequestService,
  createEasyBuzzRequest,
  getCount,
} from "../../services/topup";
import { EASY_BUZZ_URL } from "../../config";

export default {
  computed: {
    ...mapGetters("auth", ["monthlyCost"]),
  },
  components: {
    PaymentStart,
  },
  data() {
    return {
      pgParams: {},
      getCount: null,
      eassyParams: {},
      pgUrl: null,
      checkSum: null,
      name: this.$store.state["auth"].storePaymentData.name,
      emailId: this.$store.state["auth"].storePaymentData.email,
      phoneNumber: this.$store.state["auth"].storePaymentData.mobile,
    };
  },
  methods: {
    ...mapActions("auth", ["getMonthlyCost"]),
    async proceedToEassyPay() {
      try {
        const amount = this.$toFixed(this.monthlyCost);
        const customerId = this.$store.state["auth"].storePaymentData
          .customerId;
        const { name } = this;
        let phone = this.phoneNumber;
        let email = this.emailId;
        if (phone == "") {
          phone = this.$store.state["auth"].storePaymentData.mobile;
        }
        if (email == "") {
          email = "bripl_missed@gmail.com";
        }
        let payload = {
          email,
          name,
          phone,
          productInfo: "Recharge",
          amount,
          customerId,
        };
        let result = await createEasyBuzzRequest(payload);
        console.log(result);
        if (result.data) {
          window.location.href = `${EASY_BUZZ_URL}/${result.data}`;
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Please try again",
          });
        }
      } catch (err) {}
    },
    async proceedToPay() {
      try {
        const amount = this.$toFixed(this.monthlyCost);
        const customerId = this.$store.state["auth"].storePaymentData
          .customerId;
        // const mobileNo = this.$store.state["auth"].storePaymentData.mobile;
        // const email = this.$store.state["auth"].storePaymentData.email;

        let mobileNo = this.phoneNumber;
        let email = this.emailId;
        if (mobileNo == "") {
          mobileNo = this.$store.state["auth"].storePaymentData.mobile;
        }
        if (email == "") {
          email = "bripl_missed@gmail.com";
        }

        const result = await createRequestService({
          mobileNo,
          email,
          amount,
          customerId,
        });
        // const mobileNo = "9767168247";
        // const email = "bripl_missed@gmail.com";
        // const result = await createRequestService({
        //   mobileNo,
        //   email,
        //   amount,
        // });
        console.log("top up result : ", result);
        const { REDIRECT_URL, parameters } = result;
        console.log({ result: result });
        const { CHECKSUMHASH, ...pgParams } = parameters;
        this.pgParams = pgParams;
        this.pgUrl = REDIRECT_URL;
        this.checkSum = CHECKSUMHASH;
        this.$nextTick(() => {
          document.f1.submit();
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Wrong email or phone number please try again...",
        });
      }
    },
  },
  async mounted() {
    if (this.$store.state["auth"].storePaymentData.customerId) {
      this.getMonthlyCost(
        this.$store.state["auth"].storePaymentData.customerId
      );

      this.getCount = await getCount();
    } else {
      this.$router.push({
        path: "/quick-pay",
      });
    }
  },
};
</script>
<style scoped>
.rupee {
  margin-right: 5px;
  font-weight: 500 !important;
}
</style>
<style>
.topup {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}
</style>
